import { Pyramid3dRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasPickerContribution, CanvasPyramid3dPicker } from "../constants";

import { DefaultCanvasPyramid3dPicker } from "./pyramid3d-picker";

let loadPyramid3dPick = !1;

export function bindPyramid3dCanvasPickerContribution(container) {
    var _a;
    loadPyramid3dPick || (null === (_a = container.isBound) || void 0 === _a ? void 0 : _a.call(container, Pyramid3dRender)) && (loadPyramid3dPick = !0, 
    container.bind(CanvasPyramid3dPicker).toDynamicValue((() => new DefaultCanvasPyramid3dPicker(resolveContainerBinding(container, Pyramid3dRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasPyramid3dPicker));
}
//# sourceMappingURL=pyramid3d-module.js.map
